import { ILiveStream, LiveStreamStatus } from "../types/models";

/** Statuses where a worker already holds the destination list. A booting worker reads the saved one on READY. */
const WORKER_RUNNING = new Set<LiveStreamStatus>([
  LiveStreamStatus.live,
  LiveStreamStatus.finalizing,
]);

/**
 * B15: a destination edit or delete is saved, but the running worker keeps the
 * old destinations until the next "Update Live Stream", start or restart.
 */
export function destinationChangeNeedsUpdate(
  stream: Pick<ILiveStream, "id" | "status" | "desiredRunning"> | null | undefined,
  streamId: string,
  destinationEnabled: boolean
): boolean {
  return (
    !!stream &&
    stream.id === streamId &&
    stream.desiredRunning &&
    destinationEnabled &&
    WORKER_RUNNING.has(stream.status)
  );
}
